export function posterUrl(item, origin) {
  const key = item?.key;
  // Solo oggetti del sync: non utilizzare gif_path (percorso fisico del server legacy).
  if (typeof key !== "string" || !/^public\/locandine\/images\/[A-Za-z0-9]{5}\/\d+\/[a-f0-9]{64}\.(jpg|gif)$/.test(key)) return "";
  return `${origin.replace(/\/$/, "")}/${key}`;
}
